import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import i18next from 'i18next';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await authAPI.getMe();
        setUser(response.data);
        // Set system language from user preferences
        const systemLanguage = response.data.system_language || 'pt-BR';
        i18next.changeLanguage(systemLanguage);
        localStorage.setItem('systemLanguage', systemLanguage);
      } catch (error) {
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await authAPI.login(email, password);
    localStorage.setItem('token', response.data.access_token);
    await checkAuth();
    return response;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('systemLanguage'); // Clear language preference on logout
    setUser(null);
    // Reset to browser language after logout
    const browserLang = navigator.language || navigator.userLanguage;
    const detectedLang = browserLang.startsWith('en') ? 'en-US' : 'pt-BR';
    i18next.changeLanguage(detectedLang);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
